class ShopServicesCtrl {
    constructor($scope, $element, $timeout) {
    }
}

ShopServicesCtrl.$inject = ['$scope', '$element', '$timeout'];

export default ShopServicesCtrl;